// extracted by mini-css-extract-plugin
module.exports = {"mCard":"ze","image":"Ae","imageNoBackground":"Be"};